
import { Component, OnInit, Input } from '@angular/core';
import { NgSwitch } from '@angular/common';
import { Filter } from '../filter';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html'
})

export class FilterComponent implements OnInit {
    @Input()
    filter: Filter; 

    ngOnInit(): void {        
    
    }

    toggleFilterVisibility(): void {
      this.filter.open = !this.filter.open;
    }

}
